// extracted by mini-css-extract-plugin
export var editor = "_1j-0";
export var flowSidebar = "_59-2";